// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
// import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
// import ProductAddToListLink, {
//     ProductAddToListLinkStyles,
// } from "@insite/content-library/Components/ProductAddToListLink"; // Starter Custom Code
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
// import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered"; // Store Custom Code
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
// import { ButtonPresentationProps } from "@insite/mobius/Button"; // Starter Custom Code
import { SelectPresentationProps } from "@insite/mobius/Select";
// import { TextFieldProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

// Starter Custom Code
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import useIsProductRestricted from "@store/Framework/Store/Data/Products/ProductsHooks/useIsProductRestricted";
import PriceMatrix from "@store/Library/Components/Common/PriceMatrix";
import ProductInventoryDetailMessage from "@store/Library/Components/Common/ProductInventoryDetailMessage";
import ProductAddToListLink, { ProductAddToListLinkStyles } from "@store/Overrides/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import ProductPrice, { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

/* Store Custom Code - Start */
import Icon, { IconProps } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import HeartLine from "@store/Library/Components/Toolkit/Icons/Heart/HeartFill";
import CompareCheckbox, { CompareCheckboxStyles } from "@store/Library/Components/Common/CompareCheckbox";
import ProductQuantityOrdered from "@store/Overrides/Components/ProductQuantityOrdered";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";

/* Store Custom Code - End */

/* Store Custom Code - Start */
import { TextFieldProps } from "@store/MobiusOverrides/TextField/TextField";

import ProductAddToCartButton, {
    ProductAddToCartButtonProps,
} from "@store/Overrides/Components/ProductAddToCartButton";
import { actionsCardStyles } from "@store/Themes/common/props/product";
/* Store Custom Code - End */

interface OwnProps {
    showPrice: boolean;
    showAddToList: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    // Starter Custom Code
    settingsCollection: getSettingsCollection(state),
    configurationCompleted: state.pages.productDetails.configurationCompleted,
});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    // Store Custom Code
    addToCartButton?: ProductAddToCartButtonProps;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapper?: InjectableCss;

    // Starter Costum Code
    buttonRow?: InjectableCss;
    priceSection?: InjectableCss;
    availabilityStyles?: ProductAvailabilityStyles;
    // Store Custom Code
    compareCheckbox?: CompareCheckboxStyles;
    compareAddToListWrapper?: InjectableCss;
    addToListIcon?: IconProps;
}

export const actionsStyles: ProductListActionsStyles = {
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: ${pxToRem(20)};
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin-top: ${pxToRem(10)};
        `,
    },
    /* Store Custom Code - Start */
    addToCartButton: actionsCardStyles.productAddToCartButton,
    quantityOrdered: actionsCardStyles.quantityOrdered,
    addToListWrapper: actionsCardStyles.addToListWrapper,

    addToListLink: actionsCardStyles.addToListLink,
    /* Store Custom Code - End */
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: ${({ theme }) => theme.design.layout.spacing.smaller};
            flex-wrap: wrap;
            justify-content: space-between;
            width: 100%;
        `,
    },
    /* Store Custom Code */
    price: actionsCardStyles.price,
    quantityBreakPricing: actionsCardStyles.quantityBreakPricing,
    /* Store Custom Code - Start */
    buttonRow: actionsCardStyles.buttonRow,
    priceSection: actionsCardStyles.priceSection,
    compareCheckbox: actionsCardStyles.compareCheckbox,
    compareAddToListWrapper: actionsCardStyles.compareAddToListWrapper,

    /* Store Custom Code - End */
};

const styles = actionsStyles;

const ProductListActions: FC<Props> = ({
    productContext,
    productSettings,
    showPrice,
    showAddToList,
    // Starter Custom Code
    settingsCollection,
    configurationCompleted,
}) => {
    // Starter Custom Code
    const isAuthenticated = useIsSignedInAndhasToBeSignedIn();
    const { isVariantParent } = productContext.product;
    // Starter Custom Code

    /* Store Custom Code - Start */
    const showCompare = settingsCollection.productSettings.enableProductComparisons;
    const showCompareListSection = showCompare || (showAddToList && isAuthenticated);
    /* Store Custom Code - End */
    return (
        // Starter Custom Code
        <StyledWrapper
            {...styles.wrapper}
            data-test-selector={`productList_actions_${productContext.product.id}`} /* Store Custom Code */
        >
            {isAuthenticated && !isVariantParent && (
                <>
                    <StyledWrapper
                        {...styles.priceSection}
                        data-test-selector="productList_actions_priceSection" /* Store Custom Code */
                    >
                        {showPrice && (
                            <>
                                <ProductPrice
                                    product={productContext}
                                    showLabel={false}
                                    showSavings={true}
                                    showSavingsAmount={productSettings.showSavingsAmount}
                                    showSavingsPercent={productSettings.showSavingsPercent}
                                    extendedStyles={styles.price}
                                />
                            </>
                        )}
                        {settingsCollection.productSettings.showInventoryAvailability && (
                            <ProductContextAvailability
                                isProductDetailsPage={false}
                                configurationCompleted={configurationCompleted}
                                extendedStyles={styles.availabilityStyles}
                            />
                        )}
                    </StyledWrapper>
                    <ProductInventoryDetailMessage />
                    <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                </>
            )}
            <StyledWrapper
                {...styles.buttonRow}
                data-test-selector="productList_actions_buttonRow" /* Store Custom Code */
            >
                {!isVariantParent && (
                    <ProductQuantityOrdered
                        extendedStyles={styles.quantityOrdered}
                        data-test-selector={`productList_actions_quantity_${productContext.product.id}`} /* Store Custom Code */
                    />
                )}
                <ProductAddToCartButton
                    data-test-selector={`productList_actions_addToCart_${productContext.product.id}`}
                    {...styles.addToCartButton}
                />
            </StyledWrapper>
            {/* Store Custom Code */}
            {showCompareListSection && (
                <StyledWrapper
                    {...styles.compareAddToListWrapper}
                    data-test-selector="productList_actions_compareAddToListSection" /* Store Custom Code */
                >
                    <CompareCheckbox
                        extendedStyles={styles.compareCheckbox}
                        productContext={productContext}
                        data-test-selector={`productList_actions_compareCheckbox_${productContext.product.id}`} /* Store Custom Code */
                    />
                    {showAddToList && (
                        <StyledWrapper
                            {...styles.addToListWrapper}
                            data-test-selector="productList_actions_addToListWrapper" /* Store Custom Code */
                        >
                            {isAuthenticated && (
                                <ProductAddToListLink
                                    data-test-selector={`productList_actions_addToList_${productContext.product.id}`} /* Store Custom Code */
                                    extendedStyles={styles.addToListLink}
                                    showAsLink={true}
                                    /* Store Custom Code */
                                    hideIcon={false}
                                />
                            )}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            )}
        </StyledWrapper>
        // Starter Custom Code
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductListActions));
